import { render } from "./DeviationVehicleTypeInput.vue?vue&type=template&id=3fc22aae"
import script from "./DeviationVehicleTypeInput.vue?vue&type=script&lang=ts"
export * from "./DeviationVehicleTypeInput.vue?vue&type=script&lang=ts"
script.render = render

export default script